import Controller from "./districts.controller";
import template from "./districts.html";

const districts = {
  template,
  controller: Controller,
};

export default districts;



// WEBPACK FOOTER //
// ./src/pages/districts/districts.component.js